// dependencies
import { fromJS } from "immutable";

const Config = {
	width: 300,
};

export default fromJS(Config);
